import { useTranslation } from 'react-i18next'

export const usePages = () => {
  const [t] = useTranslation()
  const culturePage = {
    title: t('OpenPositionsPageCulture.pageTitle', { defaultValue: 'Culture and Values' }),
    urlPath: '/careers/culture-and-values',
    partiallyActive: true,
  }
  const lifeAtECUPage = {
    title: t('OpenPositionsPageLifeAtECU.pageTitle', { defaultValue: 'Life at Elevations' }),
    urlPath: '/careers/life-at-elevations',
    partiallyActive: true,
  }
  const DEIPage = {
    title: t('OpenPositionsPageDEI.pageTitle', { defaultValue: 'Diversity, Equity & Inclusion' }),
    urlPath: '/careers/diversity-equity-and-inclusion',
    partiallyActive: true,
  }
  const openPositionsPage = {
    title: 'Open Positions',
    urlPath: '/careers/open-positions',
    partiallyActive: true,
  }
  const careersPage = {
    title: t('OpenPositionsPageIndex.pageTitle', { defaultValue: 'Careers' }),
    urlPath: '/careers',
    children: [culturePage, lifeAtECUPage, DEIPage, openPositionsPage],
  }
  return {
    culturePage,
    lifeAtECUPage,
    DEIPage,
    openPositionsPage,
    careersPage,
  }
}
